var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9.40657","cy":"9.25057","r":"7.65657","stroke":"#FF007F","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M15.0117 14.8549L18.0007 17.8439","stroke":"#FF007F","strokeWidth":"1.5","strokeLinecap":"round","key":1})]);
}

Search.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Search;

Search.default = Search;
